import { render, staticRenderFns } from "./LoaderComponent.vue?vue&type=template&id=3d33ab7c&scoped=true&"
import script from "./LoaderComponent.vue?vue&type=script&lang=js&"
export * from "./LoaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoaderComponent.vue?vue&type=style&index=0&id=3d33ab7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33ab7c",
  null
  
)

export default component.exports